export const API_KEY_TEMPLATE: string = '*********************';